// extracted by mini-css-extract-plugin
export default {"div":"CommonsCatalogue_div__hD7kD","card":"CommonsCatalogue_card__k1+CL","cards":"CommonsCatalogue_cards__nYLBF"};